import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SkeletonSizeBase } from '../../Models/SkeletonSizesBase';

@Component({
  selector: 'skc-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.less']
})
export class ButtonComponent extends SkeletonSizeBase implements OnInit, OnChanges {
  @Input('skc-border-radius') borderRadius = '4px';
  @Input('skc-floating') floating = false;
  @Input('skc-double') double = false;
  @Input('skc-text') text: string;

  constructor() {
    super();
  }

  ngOnInit() {
    this.initProperties();
    this.actionsFloating();
  }

  private actionsFloating() {
    this.updateWidthIfIsFloating();
    this.updateBorderRadiusIfIsFloating();
    this.changeTextOfButtonIfIsFloating(this.text);
  }

  private updateWidthIfIsFloating() {
    if (this.floating) {
      this.width = this.height;
    } else {
      this.width = '6.25em';
      this.height = '2.5em';
    }
  }

  private initProperties() {
    this.width = '6.25em';
    this.height = '2.5em';
  }

  private updateBorderRadiusIfIsFloating() {
    if (this.floating && this.borderRadius === '4px') {
      this.borderRadius = '50%';
    } else if (!this.floating && this.borderRadius === '50%') {
      this.borderRadius = '4px';
    }
  }

  private changeTextOfButtonIfIsFloating(currentValue: string) {
    if (this.floating) {
      this.text = '';
    } else {
      this.text = currentValue;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.floating) {
      this.actionsFloating();
    }
    if (changes.text) {
      this.changeTextOfButtonIfIsFloating(changes.text.currentValue);
    }
    if (
      (changes.width && !changes.width.firstChange && changes.width.currentValue === '') ||
      (changes.height && !changes.height.firstChange && changes.height.currentValue === '')
    ) {
      this.initProperties();
    }
  }
}
